/* =========================================================
   PETEY PAR — Theme JS
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Mobile nav ---------- */
  function initNav() {
    var burger = document.querySelector('[data-burger]');
    var menu = document.querySelector('[data-mobile-nav]');
    if (!burger || !menu) return;
    burger.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Email popup (session-dismiss) ---------- */
  function initPopup() {
    var backdrop = document.querySelector('[data-popup-backdrop]');
    var popup = document.querySelector('[data-popup]');
    if (!backdrop || !popup) return;
    var delay = parseInt(popup.getAttribute('data-delay') || '800', 10);
    var dismissed = sessionStorage.getItem('pp_popup_dismissed');
    function close() {
      backdrop.classList.remove('is-open');
      popup.classList.remove('is-open');
      sessionStorage.setItem('pp_popup_dismissed', 'true');
    }
    function open() {
      backdrop.classList.add('is-open');
      popup.classList.add('is-open');
    }
    if (!dismissed) { setTimeout(open, delay); }
    backdrop.addEventListener('click', close);
    popup.querySelectorAll('[data-popup-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    // Don't reopen after a successful signup
    var form = popup.querySelector('form');
    if (form) form.addEventListener('submit', function () { sessionStorage.setItem('pp_popup_dismissed', 'true'); });
  }

  /* ---------- Product: gallery + variants + qty ---------- */
  function initProduct() {
    var root = document.querySelector('[data-product]');
    if (!root) return;

    // Thumbnails
    var main = root.querySelector('[data-product-main-image]');
    root.querySelectorAll('[data-thumb]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (main) { main.src = t.getAttribute('data-full'); main.srcset = ''; }
        root.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });

    // Quantity
    var qtyInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(b.getAttribute('data-qty-step'), 10);
        var v = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = v;
      });
    });

    // Variant selection
    var variants = [];
    try { variants = JSON.parse(root.querySelector('[data-variant-json]').textContent); } catch (e) {}
    var selected = {};
    var idInput = root.querySelector('[data-variant-id]');
    var priceEl = root.querySelector('[data-product-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var moneyFmt = root.getAttribute('data-money-format') || '${{amount}}';

    function formatMoney(cents) {
      var amount = (cents / 100).toFixed(2);
      return moneyFmt.replace(/\{\{\s*amount\s*\}\}/, amount);
    }
    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === opt; });
      });
    }
    function update() {
      var v = findVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceEl.innerHTML = '<s>' + formatMoney(v.compare_at_price) + '</s> <span class="pp-sale">' + formatMoney(v.price) + '</span>';
        } else {
          priceEl.textContent = formatMoney(v.price);
        }
      }
      if (addBtn) {
        if (v.available) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-add-label') || 'Add to Cart'; }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
      }
    }
    root.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-option-index'), 10);
      var active = group.querySelector('.pp-swatch.is-active');
      if (active) selected[idx] = active.getAttribute('data-value');
      group.querySelectorAll('.pp-swatch').forEach(function (sw) {
        sw.addEventListener('click', function () {
          selected[idx] = sw.getAttribute('data-value');
          group.querySelectorAll('.pp-swatch').forEach(function (x) { x.classList.remove('is-active'); });
          sw.classList.add('is-active');
          update();
        });
      });
    });
    update();
  }

  /* ---------- AJAX add to cart + count badge ---------- */
  function refreshCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? 'inline-flex' : 'none';
        });
      }).catch(function () {});
  }

  function initAjaxCart() {
    document.querySelectorAll('form[action="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[data-add-to-cart]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(serialize(form))
        }).then(function (r) { return r.json(); })
          .then(function () {
            refreshCartCount();
            if (btn) { btn.textContent = 'Added ✓'; setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600); }
          }).catch(function () {
            if (btn) { btn.disabled = false; btn.textContent = label; }
            form.submit();
          });
      });
    });
  }

  function serialize(form) {
    var data = { items: [{ id: null, quantity: 1 }] };
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    data.items[0].id = id ? id.value : null;
    data.items[0].quantity = qty ? parseInt(qty.value, 10) || 1 : 1;
    return data;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initPopup();
    initProduct();
    initAjaxCart();
    refreshCartCount();
  });
})();
